module.exports = __webpack_public_path__ + "img/KALM.9a85e697.png";